module.exports = __webpack_public_path__ + "img/61.a5c82e8c.png";